<div class="investor mb-footer">
    <div class="banner">
        <app-banner-header [dataBanner]="dataBanner" [fontSize]="'long-word'"></app-banner-header>
    </div>
    <div class="page-able">
        <router-outlet></router-outlet>
    </div>
</div>

